import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/pinned-posts")({
  component: () => null,
});
